export default __webpack_public_path__ + "locales/ar-SA/UploadPanel.json?hash=cbbf994843c17e68f023d32b772fe77b";